const sessionConfigState = {
    VerifyTwoFactor: null
}

export default {
    ...sessionConfigState
}